import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';


@Injectable({
  providedIn: 'root'
})
export class MachineMappingService {
  // tslint:disable-next-line:typedef
  get NetApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  getMachineMappingData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Account/GetMachineMappingList', data);
  }

  getPlantsData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Common/GetDepartments', data);

  }

  getDepartmentData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Common/GetDepartmentByPlant', data);
  }
  getDepartmenBytPlant(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.apiUrl + 'getdepartmentbyplant', data);
    return this.http.post<any[]>(this.NetApiUrl + 'Machine/GetDepartmentByPlant', data);
  }

  getAllDepartmentData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'CommonIntegrated/GetAllDepartmentByPlant', data);
  }
  getProductData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Common/GetProdLine', data);
  }

  getUnitData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Common/GetProdUnit', data);
  }

  AddMachineData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Account/SumbitMachineMapping', data);
  }
  // getLineList(data: any): Observable<any[]> {
  //   return this.http.post<any[]>(this.NetApiUrl + 'Dashboard/GetLineList', data);
  // }
  getLineList(data: any): Observable<any[]> {
    return this.http.get<any[]>(this.NetApiUrl + 'Dashboard/GetLineList');
  }
  getUnitList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Dashboard/GetUnitList', data);
  }
  getAssemblyList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Dashboard/GetAssemblyList', data);
  }
  getComponentListByAssembly(data: any): Observable<any> {
    return this.http.post<any>(this.NetApiUrl + 'Dashboard/GetComponentListByAssembly', data);
  }

  getComponentListBySubAssembly(data: any): Observable<any> {
    return this.http.post<any>(this.NetApiUrl + 'Dashboard/GetComponentListBySubAssembly', data);
  }

  getUnitbyUser(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Machine/GetUnitsByUser', data);
  }
  getDepartmentsByPlant(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'Machine/GetDepartmentByPlant', data);
  }
  async getComponentbyUnit(data: any): Promise<any> {
    return await this.http.post<any>(this.NetApiUrl + 'Machine/GetComponentByUnit', data).toPromise();
  }

  getSubAssemblyList(data: any): Observable<any> {
    return this.http.post<any>(this.NetApiUrl + 'CIL/GetSubAssemblyListByAssemblyId', data);
  }

}
